import ChallengePage from './Challenge.page'

const ChallengeEntry = () => {
  return <ChallengePage></ChallengePage>
}
export default ChallengeEntry
